import Vue from 'vue'
import Resource from 'vue-resource'
import Router from 'vue-router'

import App from '~/components/App.vue'
import Home from '~/components/Home.vue'
import Section from '~/components/Section.vue'

// Install plugins
Vue.use(Router);
Vue.use(Resource);
// route config
let routes = [{
    path: '/home',
    name: 'home',
    component: Home
}, {
    path: '/:code/:type',
    name: 'Section',
    component: Section
},
    {path: '*', redirect: '/home'}
];

// Set up a new router
let router = new Router({
    routes: routes
});
fetch('./json/data.json')
    .then(r => r.json())
    .then(r => {
        let response = r;
        let checkEmeaParam = /filter=emea/gi.test(window.location.href);
        checkEmeaParam && response.config.type.pop();
        Vue.prototype.$appConfig = response.config;
        Vue.prototype.$appData = response.sections;
        // Start up our app
        new Vue({
            router: router,
            render: h => h(App),
        }).$mount('#app');
    })